// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#collaborate-comment-add[data-v-abb4f874]{position:relative;background-color:#fff;z-index:2;box-shadow:0 .75rem 1.5rem rgba(18,38,63,.03)}#collaborate-comment-add.static[data-v-abb4f874]{position:static}", ""]);
// Exports
module.exports = exports;
